import React, { useState } from "react";
import { Link } from "react-router-dom";
import OpsManagerList from "./opsmgrlst";
import SportCoachList from "./sportcoachlist";
import Nutritionist from "./nutritionist";
import Physiotherapist from "./physiotherapist";

const ManageTab = () => {

    const [activeTab, setActiveTab] = useState("Ops Manager");
    const roleId = localStorage.getItem('RoleId');

    const tabData = [
        {
            icon: <i className="fas fa-university" />,
            name: "Ops Manager",
            content: <OpsManagerList />
        },
        {
            icon: <i className="fas fa-tasks" />,
            name: "Sport-Coach",
            content: <SportCoachList />
        },
        ...((roleId != '7') ? [
        {
            icon: <i className="fas fa-user-clock" />,
            name: "Nutritionist",
            content: <Nutritionist />
        },
        {
            icon: <i className="fas fa-user-md" />,
            name: "Physiotherapist",
            content: <Physiotherapist />
        }
        ] : [])
    ]
    return (
        <>
            <div className="row">
                <div className="sortby-section">
                    <div className="row d-flex align-items-center" style={{ marginTop: "1rem" }}>
                        <div className="col-xl-12 col-lg-12 col-sm-12 col-md-12">
                            <div className="coach-court-list">
                                <ul className="nav">
                                    {tabData.map((tab, i) => (
                                        <li key={i}>
                                            <Link to="#"
                                                className={tab.name === activeTab ? 'active' : ''}
                                                onClick={() => setActiveTab(tab.name)}>
                                                {tab.icon}  {tab.name}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                        <div className="tab-content">
                            {tabData
                                .filter(tab => tab.name === activeTab)
                                .map((tab, i) => (
                                    <div key={i}>{tab.content}</div>
                                ))}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ManageTab;